import { render, staticRenderFns } from "./VideoVue.vue?vue&type=template&id=29a770c2&scoped=true&"
import script from "./VideoVue.vue?vue&type=script&lang=js&"
export * from "./VideoVue.vue?vue&type=script&lang=js&"
import style0 from "./VideoVue.vue?vue&type=style&index=0&id=29a770c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a770c2",
  null
  
)

export default component.exports